/**
 * Gemensamma formaterings-helpers för Lyktan-vyer (S-04-16).
 *
 * Tidigare hade AdminUsersView, HearthsView, PilotAccountsView och
 * ReportDetail varsin lokal kopia av samma datum-formatering. Vi
 * konsoliderar dem här så att tidsstämplar ser likadana ut överallt
 * och så att en framtida ändring (t.ex. annan tidszon) bara behöver
 * göras på ett ställe.
 */

/**
 * Formaterar ISO-8601-tidsstämpel som svenskt "ÅÅÅÅ-MM-DD HH:MM"
 * (sv-SE locale). Returnerar `"—"` för `null`/`undefined`/tom sträng
 * och faller tillbaka till råtexten om parsing misslyckas — vyn ska
 * aldrig krascha på oväntad backend-payload.
 */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return iso;
    return date.toLocaleString('sv-SE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}
